<div class="neq-page-wrapper">
  <div class="neq-page">
    <form [formGroup]="form" (ngSubmit)="onFormSubmit()" fxLayout="row" fxLayoutAlign="start start"
          fxLayoutGap="0.714rem">
      <div class="neq-container" fxLayout="column" fxFlex>
        <h1>{{ 'label.user.export.settings' | translate }}</h1>
        <p>{{ 'label.user.export.settings.warning-message' | translate }}</p>
        <mat-checkbox formControlName="enabled" (change)="onEnabled($event)" #checkboxExport>{{ 'label.user.export.settings.enabled' | translate }}</mat-checkbox>

        <div *ngIf="checkboxExport.checked" style="width: min-content;">
          <mat-form-field>
            <mat-select formControlName="format" [placeholder]="'label.user.export.settings.format' | translate">
              <mat-option *ngFor="let format of availableValues" [value]="format">{{ format }}</mat-option>
            </mat-select>
            <mat-error>
              {{ 'error.common.field-required' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div *ngIf="checkboxExport.checked">
          <mat-checkbox fxLayout="row" *ngFor="let chosenFormat of chosenFormats; let i=index" formControlName="{{chosenFormat[0]}}" [checked]="chosenFormat[1]"
          (change)="showOptions(i, chosenFormat, $event)" style="margin-right: 10px;">
            {{ chosenFormat[0] }}
          </mat-checkbox>
        </div>

        <div fxLayout="row">
          <mat-form-field fxFlex="33">
            <input select-all matInput required [placeholder]="'label.user.export.settings.limit-export' | translate"
              formControlName="limitExport" type="number" step="1">
            <mat-error *ngIf="form.controls.limitExport.errors?.min" [translate]="'error.common.numeric.min'"
                        [translateParams]="{ param: 10}"></mat-error>
            <mat-error *ngIf="form.controls.limitExport.errors?.max" [translate]="'error.common.numeric.max'"
                        [translateParams]="{ param: 500}"></mat-error>
            <mat-error *ngIf="form.controls.limitExport.errors?.pattern">{{'error.common.numeric.int' | translate}}</mat-error>
            <mat-error *ngIf="form.controls.limitExport.errors?.required">{{'error.common.field-required' | translate}}</mat-error>
          </mat-form-field>
        </div>

        <div fxLayout="row">
          <mat-form-field fxFlex="33">
            <input select-all matInput required [placeholder]="'label.user.export.settings.limit-import' | translate"
              formControlName="limitImport" type="number" min="10" max="500" step="1">
            <mat-error *ngIf="form.controls.limitImport.errors?.min" [translate]="'error.common.numeric.min'"
                        [translateParams]="{ param: 10}"></mat-error>
            <mat-error *ngIf="form.controls.limitImport.errors?.max" [translate]="'error.common.numeric.max'"
                        [translateParams]="{ param: 500}"></mat-error>
            <mat-error *ngIf="form.controls.limitImport.errors?.pattern">{{'error.common.numeric.int' | translate}}</mat-error>
            <mat-error *ngIf="form.controls.limitImport.errors?.required">{{'error.common.field-required' | translate}}</mat-error>
          </mat-form-field>
        </div>

      </div>

      <div class="neq-action-button" fxLayoutAlign="end center">
        <button pButton
          [disabled]="form.pristine"
          class="neq-primeng-button primeng-flat"
          [matTooltip]="'msg.common.icon.save' | translate"
          type="submit"
        >
          <neq-icon svgIcon="enregistrer"></neq-icon>
        </button>
      </div>
    </form>
  </div>
</div>
